<web-design-system-modal
  data-zid="ftg-experience-container"
  [headline]="'user-self-service.activate-ftg-modal.notice' | transloco"
  (dismiss)="modal.close('cancel')"
>
  <p class="zero-text p-base-reg" data-zid="ftg-link" [innerHTML]="'user-self-service.activate-ftg-modal.description-text' | transloco"></p>
  <p class="zero-text p-base-reg mb-4">{{ 'user-self-service.activate-ftg-modal.confirm-tan' | transloco }}</p>
  @if (showExperienceNotice && dialogMode) {
    <web-design-system-notification color="blue" class="d-block mb-4">
      <p class="zero-text p-bigger-bold">
        @if (dialogMode.experienceNoticeLeverage) {
          {{ 'trade.create.check-experience-and-ftg.showExperienceNotice.experienceNoticeLeverage.headline' | transloco }}
        }
        @if (dialogMode.experienceNoticeNonLeverage) {
          {{ 'trade.create.check-experience-and-ftg.showExperienceNotice.experienceNoticeNonLeverage.headline' | transloco }}
        }
      </p>
      <p class="zero-text p-base-reg">
        @if (!dialogMode.experienceNoticeNoInfoProvided) {
          {{ 'trade.create.check-experience-and-ftg.showExperienceNotice.showExperienceNoticeNoInfoProvided.no' | transloco }}
        }
        @if (dialogMode.experienceNoticeNoInfoProvided) {
          {{ 'trade.create.check-experience-and-ftg.showExperienceNotice.showExperienceNoticeNoInfoProvided.yes' | transloco }}
        }
      </p>
    </web-design-system-notification>
  }
  <web-design-system-divider />

  @if (dataToAuthorize) {
    <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
  }

  <web-components-user-messages />
</web-design-system-modal>
